import React, { FC } from "react";
import { Backdrop, Button, CircularProgress, Modal } from "@mui/material";
import styles from "./RemoveModal.module.scss";

interface RemoveModalProps {
  /** Callback to close modal and cancel block action */
  onClose: () => void;
  onSubmit: (userIds: string) => void;
  isSubmitting?: boolean;
  draftId: string | null;
}

const RemoveModal: FC<RemoveModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
  draftId,
}) => {
  const handleConfirm = () => {
    draftId && onSubmit(draftId);
  };

  return (
    <div className="create-promotion-modal">
      {/* Full-screen Backdrop */}
      <Modal
        open={true}
        onClose={onClose}
        aria-labelledby="remove-modal-title"
        aria-describedby="remove-modal-description"
      >
        {/* Modal Container */}
        <div className={styles["modalContainer"]}>
          {/* Modal Title */}
          <h4 className={styles["modalContainer__title"]}>Remove?</h4>

          {/* Confirmation Message */}
          <div className={styles["modalContainer__inputWrapper"]}>
            Are you sure you want to remove this draft entry?
          </div>

          {/* Action Buttons Container */}
          <div className={styles["modalContainer__buttonGroup"]}>
            {/* Cancel Button - Closes modal without blocking */}
            <Button
              onClick={onClose}
              type="button"
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isSubmitting} // Disabled during block to prevent cancellation
            >
              Cancel
            </Button>

            {/* Confirm Button - Initiates block process */}
            <Button
              onClick={handleConfirm}
              type="button"
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isSubmitting} // Disabled during block to prevent duplicate requests
            >
              {/* Show loading spinner during block, otherwise show "Remove Draft" text */}
              {isSubmitting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Remove"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RemoveModal;
